import { render } from "./App.vue?vue&type=template&id=683bf876"
const script = {}

import "./App.vue?vue&type=style&index=0&id=683bf876&lang=css"

import exportComponent from "/Users/reahmiyara/Code/226CliftonPlace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__